import Vue from "vue";

import CustomizationSection from './CustomizationSection';

Vue.config.productionTip = false;

new Vue({
  el: '[data-vue="customization-section"]',
  components: {
    CustomizationSection
  }
});
